import React from "react";
import Header from "../Components/Header/Header";
import Contact from "../Components/ContactSection/Contact";
import RecentMovieSection from "../Components/RecentMovieSection/RecentMovieSection";
import HeroSection from "../Components/HeroSection/HeroSection";
import Upcoming from "../Components/UpcomingSection/Upcoming";
import OurFounder from "../Components/OurFounder/OurFounder";
import Vision from "../Components/VisionSection/Vision";
import Banner from "../Components/BannerSection/Banner";
import NewsandUpdate from "../Components/NewsandUpdatesSection/NewsandUpdate";
import OurProductionSection from "../Components/OurProductionSection/OurProductionSection";
import AboutUsSection from "../Components/AboutSection/About";
import SoundtrackSection from "../Components/SoundtrackSection/Soundtrack";

const HeaderView = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <RecentMovieSection />
      <AboutUsSection />
      <Vision />
      <Banner />
      <OurFounder />
      <OurProductionSection />
      <Upcoming />
      <NewsandUpdate />
      <SoundtrackSection />
      <Contact />
    </div>
  );
};

export default HeaderView;
